import instance, {
  Axios,
  AxiosResponse,
  AxiosError,
  AxiosRequestConfig,
} from 'axios'

import get from 'lodash/get'

import { Cookies } from 'react-cookie'

let isRefreshing: boolean = false
let failedRequestsQueue: any[] = []

export function axios(): Axios {
  const api = instance.create({
    baseURL: 'https://parkoff-api.herokuapp.com/',
  })

  // const api = instance.create({
  //   baseURL: process.env.REACT_APP_PARKOFF_API_URL,
  // })

  /* const api = instance.create({
    baseURL:
      'https://3d4f-2804-7f2-2981-3fbf-78e5-105f-3af5-858.ngrok-free.app',
  }) */

  api.interceptors.request.use((config: AxiosRequestConfig) => {
    const token = new Cookies().get('parkoff.token')

    config.headers = {
      Authorization: `Bearer ${token}`,
    }

    return config
  })

  api.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
      if (get(error, ['response', 'status']) === 401) {
        if (get(error, ['response', 'data', 'message']) === 'jwt expired') {
          const cookies = new Cookies()

          const old_token = cookies.get('parkoff.token')

          const originalConfig = error.config

          if (!isRefreshing) {
            isRefreshing = true

            api
              .put('/auth/refresh', {
                old_token,
              })
              .then(response => {
                const { access_token } = response.data

                cookies.set('parkoff.token', access_token, {
                  maxAge: 60 * 30,
                  path: '/',
                })

                failedRequestsQueue.forEach(request =>
                  request.onSuccess(access_token)
                )
                failedRequestsQueue = []
              })
              .catch(err => {
                failedRequestsQueue.forEach(request => request.onFailure(err))
                failedRequestsQueue = []

                if (window) {
                  cookies.set('parkoff.token', '', { maxAge: -1 })
                }
              })
              .finally(() => {
                isRefreshing = false
              })
          }

          return new Promise((resolve, reject) => {
            failedRequestsQueue.push({
              onSuccess: (token: string) => {
                originalConfig.headers = {
                  Authorization: `Bearer ${token}`,
                }

                resolve(api(originalConfig))
              },
              onFailure: (err: AxiosError) => {
                reject(err)
              },
            })
          })
        } else {
          return Promise.reject(error)
        }
      }

      return Promise.reject(error)
    }
  )

  return api
}
